import { GridRowId } from '@mui/x-data-grid/models/gridRows'
import { ThunkDispatch } from 'redux-thunk'
import { TransactionsFiltersBody } from 'src/components/TransactionsListFilter/transactionsFilter.schema'
import {
  TransactionDetailResponse,
  TransactionListResponse,
} from 'src/models/transaction.models'
import { RootState } from 'src/redux/createRootReducer'

export const GET_TRANSACTION_INIT = 'data/transactions/GET_TRANSACTION_INIT'
export const GET_TRANSACTION_SUCCESS =
  'data/transactions/GET_TRANSACTION_SUCCESS'
export const GET_TRANSACTION_FAILURE =
  'data/transactions/GET_TRANSACTION_FAILURE'

export type GetTransactionSuccessPayload = TransactionDetailResponse

export interface GetTransactionInitAction {
  type: typeof GET_TRANSACTION_INIT
}
export interface GetTransactionSuccessAction {
  type: typeof GET_TRANSACTION_SUCCESS
  payload: GetTransactionSuccessPayload
}
export interface GetTransactionFailureAction {
  type: typeof GET_TRANSACTION_FAILURE
  payload: unknown
}

export type GetTransactionActions =
  | GetTransactionInitAction
  | GetTransactionSuccessAction
  | GetTransactionFailureAction

export interface GetReportTransactionsInitPayload {
  queryParams: GetReportTransactionsQueryParams
}

export interface GetReportTransactionsSuccessPayload {
  report: {
    transactions: TransactionListResponse[]
    page: number
    perPage: number
    count: number
    numPages: number
  }
  queryParams: GetReportTransactionsQueryParams
}

export interface GetReportTransactionsFailurePayload {
  queryParams: GetReportTransactionsQueryParams
}

export interface GetReportTransactionsQueryParams {
  search?: string
  creditCardId?: string[]
  includeBudgets?: boolean
  virtualCardId?: string[]
  status?: string[]
  source?: string[]
  since?: string
  until?: string
  perPage?: number
  page?: number
  sort?: string
  mccGroup?: string[]
  recipientId?: string[]
  organizationExpenseReportId?: string
}

export const GET_YOUR_REPORT_TRANSACTIONS_INIT =
  'data/transactions/GET_YOUR_REPORT_TRANSACTIONS_INIT'
export const GET_YOUR_REPORT_TRANSACTIONS_SUCCESS =
  'data/transactions/GET_YOUR_REPORT_TRANSACTIONS_SUCCESS'
export const GET_YOUR_REPORT_TRANSACTIONS_FAILURE =
  'data/transactions/GET_YOUR_REPORT_TRANSACTIONS_FAILURE'

export interface GetReportYourTransactionsInitAction {
  type: typeof GET_YOUR_REPORT_TRANSACTIONS_INIT
  payload: GetReportTransactionsInitPayload
}
export interface GetReportYourTransactionsSuccessAction {
  type: typeof GET_YOUR_REPORT_TRANSACTIONS_SUCCESS
  payload: GetReportTransactionsSuccessPayload
}
export interface GetReportYourTransactionsFailureAction {
  type: typeof GET_YOUR_REPORT_TRANSACTIONS_FAILURE
  payload: GetReportTransactionsFailurePayload
}

export type GetReportYourTransactionsActions =
  | GetReportYourTransactionsInitAction
  | GetReportYourTransactionsSuccessAction
  | GetReportYourTransactionsFailureAction

export type UpdateSelectedTransactionActions = UpdateSelectedTransactionAction
export const UPDATE_SELECTED_TRANSACTIONS =
  'data/transactions/UPDATE_SELECTED_TRANSACTIONS'
export interface UpdateSelectedTransactionAction {
  type: typeof UPDATE_SELECTED_TRANSACTIONS
  payload: {
    selectedTransactions: Set<GridRowId>
  }
}
export const updateSelectedTransactions = (
  selectedTransactions?: Set<GridRowId>,
) => {
  return (
    dispatch: ThunkDispatch<RootState, void, UpdateSelectedTransactionAction>,
  ): void => {
    dispatch({
      type: UPDATE_SELECTED_TRANSACTIONS,
      payload: {
        selectedTransactions: new Set(selectedTransactions ?? []),
      },
    })
  }
}

export type UpdateSelectAllTransactionsBoxVisibleActions =
  UpdateSelectAllTransactionsBoxVisibleAction
export const UPDATE_SELECT_ALL_TRANSACTIONS_BOX_VISIBLE =
  'data/transactions/UPDATE_SELECT_ALL_TRANSACTIONS_BOX_VISIBLE'
export interface UpdateSelectAllTransactionsBoxVisibleAction {
  type: typeof UPDATE_SELECT_ALL_TRANSACTIONS_BOX_VISIBLE
  payload: {
    selectAllTransactionsBoxVisible: boolean
  }
}
export const updateSelectAllTransactionsBoxVisible = (
  selectAllTransactionsBoxVisible: boolean,
) => {
  return (
    dispatch: ThunkDispatch<
      RootState,
      void,
      UpdateSelectAllTransactionsBoxVisibleAction
    >,
  ): void => {
    dispatch({
      type: UPDATE_SELECT_ALL_TRANSACTIONS_BOX_VISIBLE,
      payload: {
        selectAllTransactionsBoxVisible,
      },
    })
  }
}

export type UpdateSelectAllTransactionsFiltersActions =
  UpdateSelectAllTransactionsFiltersAction
export const UPDATE_SELECT_ALL_TRANSACTIONS_FILTERS =
  'data/transactions/UPDATE_SELECT_ALL_TRANSACTIONS_FILTERS'
export interface UpdateSelectAllTransactionsFiltersAction {
  type: typeof UPDATE_SELECT_ALL_TRANSACTIONS_FILTERS
  payload: {
    selectAllTransactionsFilters: TransactionsFiltersBody | undefined
  }
}
export const updateSelectAllTransactionsFilters = (
  selectAllTransactionsFilters: TransactionsFiltersBody | undefined,
) => {
  return (
    dispatch: ThunkDispatch<
      RootState,
      void,
      UpdateSelectAllTransactionsFiltersAction
    >,
  ): void => {
    dispatch({
      type: UPDATE_SELECT_ALL_TRANSACTIONS_FILTERS,
      payload: {
        selectAllTransactionsFilters,
      },
    })
  }
}
